'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotPolarFilledIcon = function PlotPolarFilledIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M19.188 7.375c2.25.125 4.5 1.063 6.25 2.563l-6.25 6.313zm1.062 9.563h6.063c-.125-1.25-.75-3.125-1.75-4.313zm5.625 7c1.375-1.625 2.25-3.438 2.375-5.688h-8zM19.188 29a10.928 10.928 0 0 0 6.813-2.813l-6.813-6.813zm-1.25 1.438V19.375l-7.813 7.813a13.045 13.045 0 0 0 7.813 3.25zM4.875 18.25C5.063 21.438 6.313 24.563 8.5 27l8.625-8.75zm2.75-10.875c-2.375 2.688-3.75 6.375-3.875 9.563h13.375zm10.313-5.75c-3.563.188-7.438 1.688-10.25 4.313l10.25 10.313z' })
    );
};

exports.default = PlotPolarFilledIcon;